import { useMemo } from 'react';
import { useStore } from 'react-redux';

import { isLoggedIn } from '../../../common/Helpers';

export const usePlanExtrasHooks = (isLoaded) => {
  const { cartDetails: cart = {}, cBandPlans } = useStore().getState();
  const userType = isLoggedIn() ? 'aal' : 'nse';

  const getPlanExtras = useMemo(() => {
    const { willowPlanExtras = {} } = cBandPlans?.plansDetails || {};
    const { dueMonthlyList = [] } = cart?.cartDetailsJson || {};

    const planId = dueMonthlyList.find((item) => item?.itemType === 'PLAN')?.productId;
    const extras = planId ? willowPlanExtras[planId] : null;

    const planExtras = {
      planId,
      userType,
      extrasCallout: '',
      extrasCommonDesc: '',
      planChoiceList: [],
      choiceOlayTtl: [],
      choiceOlayDesc: [],
      choiceOlayStepsHead: [],
      choiceOlaySteps: [],
      choiceOlayFtr: [],
    };

    if (extras) {
      planExtras.extrasCallout = extras[`extrasCallout_${userType}`] || '';
      planExtras.extrasCommonDesc = extras[`extrasCommonDesc_${userType}`] || '';
      planExtras.choiceOlayTtl = extras[`choiceOlayTtl_${userType}`] || [];
      planExtras.choiceOlayDesc = extras[`choiceOlayDesc_${userType}`] || [];
      planExtras.choiceOlayStepsHead = extras[`choiceOlayStepsHead_${userType}`] || [];
      planExtras.choiceOlaySteps = extras[`choiceOlaySteps_${userType}`] || [];
      planExtras.choiceOlayFtr = extras[`choiceOlayFtr_${userType}`] || [];

      if (planExtras.choiceOlayTtl.length) {
        planExtras.planChoiceList = Array(planExtras.choiceOlayTtl.length)
          .fill(0)
          .map((e, i) => i);
      }
    }

    return {
      planId,
      planExtras,
    };
  }, [isLoaded]);

  return getPlanExtras;
};
